module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "contactDebtorList"
    }
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#contact-debtors-list",
      "placeholder": _vm.$t('requestToPay.srch_in_cntcts')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "webdatalist"
  }, [_c('f7-list', {
    attrs: {
      "id": "contact-debtors-list",
      "contacts": ""
    }
  }, _vm._l((this.contactSelectionList), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(contact) {
      return _c('li', {
        attrs: {
          "disabled": _vm.isContactAvailable(contact)
        },
        on: {
          "change": function($event) {
            return _vm.changeItem()
          }
        }
      }, [_c('label', {
        staticClass: "item-radio item-content boxRequest"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.contactDebtors),
          expression: "contactDebtors"
        }],
        staticClass: "inputContact",
        attrs: {
          "type": "radio",
          "name": "contactDebtorCheckbox"
        },
        domProps: {
          "value": contact.id,
          "checked": _vm._q(_vm.contactDebtors, contact.id)
        },
        on: {
          "change": function($event) {
            _vm.contactDebtors = contact.id
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "icon icon-radio"
      }), _vm._v(" "), _c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(contact.label))])])])])
    })], 2)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: _vm.colorBottomButton
  }, [_c('f7-button', {
    staticClass: "orangeConfirmationButton",
    attrs: {
      "round": "",
      "title": "cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('f7-link', [_vm._v(" " + _vm._s(_vm.$t('common.cncl')))])], 1)], 1)])], 1), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0eaeafc6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eaeafc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/ContactDebtorList.vue
// module id = 2283
// module chunks = 2